import {mixins} from "../app/mixin";

mixins.push({
    el: '.stepper',
    data() {
        return {
            activeStep: 1,
        }
    }, methods: {
        setActiveStep(step) {
            this.activeStep = step;
        },
    },
});